import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ObjectiveActionsValidationSchema } from "../schemas/objectiveActions.schema";

interface UseCreateObjectiveActionProps {
  onSuccess?: () => void
  onError?: (error: any) => void
}

const useCreateObjectiveAction = ({ onSuccess, onError }: UseCreateObjectiveActionProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createMaintenanceObjectiveAction'],
    mutationFn: (data: ObjectiveActionsValidationSchema) => {
      const payload = {
        objective_action: {
          display_name: data.display_name,
          description: data.description,
        }
      }

      return privateAxios.post('/maintenance/objective_actions', payload);
    },
    onSuccess,
    onError,
  });
}

export default useCreateObjectiveAction;
